import { NgModule } from '@angular/core';
import { AuthPortalGuard } from '../../shared/services/auth-guard';
import { Routes, RouterModule } from '@angular/router';
import { ApplicationTypesComponent } from './application-types.component';
import { ApplicationCreateComponent } from './application-create/application-create.component';
import { TypesListComponent } from './types-list/types-list.component';
import { MunicipalitiesResolve } from '../../shared/services/municipalities.resolve';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthPortalGuard],
        component: ApplicationTypesComponent,
        children: [
            { path: 'list', component: TypesListComponent },
            {
                path: ':id/create',
                component: ApplicationCreateComponent,
                resolve: {
                    municipalities: MunicipalitiesResolve
                },
            },
            { path: '', redirectTo: 'list', pathMatch: 'full' }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ApplicationTypesRoutingModule { }
